import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
import PrivateRoute from "./PrivateRoute";
import constants from "../common/constants";
import Blog from "../pages/blog";
import AddBlog from "../pages/blog/addBlog";
import Gallery from "../pages/gallery";
import PrArticle from "../pages/prArticle";
import AddPrArticle from "../pages/prArticle/AddPrArticle";
import MenuArticle from "../pages/menuArticle";
import AddMenuArticle from "../pages/menuArticle/AddMenuArticle";
const CaseStudies = LazyLoad(lazy(() => import("../pages/case-studies")));
const AddCaseStudies = LazyLoad(
  lazy(() => import("../pages/case-studies/AddCaseStudies")),
);
const Categories = LazyLoad(lazy(() => import("../pages/categories")));
const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const UserProfile = LazyLoad(lazy(() => import("../pages/user-profile")));
const { ADMIN, USER } = constants;

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "/app",
      element: <PrivateRoute element={<Dashboard />} requiredRole={[ADMIN]} />,
    },
    {
      path: "/app/blogs",
      element: <PrivateRoute element={<Blog />} requiredRole={[ADMIN]} />,
    },
    {
      path: "/app/blog/add",
      element: <PrivateRoute element={<AddBlog />} requiredRole={[ADMIN]} />,
    },
    {
      path: "/app/case-studies",
      element: <CaseStudies />,
    },

    {
      path: "/app/categories",
      element: <Categories />,
    },

    {
      path: "/app/add-case-studies",
      element: <AddCaseStudies />,
    },
    {
      path: "/app/pr-articles",
      element: <PrArticle />,
    },

    {
      path: "/app/add-pr-article",
      element: <AddPrArticle />,
    },
    {
      path: "/app/menu-articles",
      element: <MenuArticle />,
    },
    {
      path: "/app/add-menu-article",
      element: <AddMenuArticle />,
    },
    {
      path: "/app/gallery",
      element: <Gallery />,
    },
    {
      path: "/app/user-profile",
      element: <UserProfile />,
    },
  ],
};

export default AdminRoutes;
